<template>
  <div class="cart_row package" v-if="false">
    <div class="flex" style="margin-bottom: 10px;">
      <!--      <figure ></figure>-->
      <router-link tag="figure" :to="link" activeClass="active" :style="'background-image: url(' + photo + ')'"></router-link>
      <router-link class="hgroup" :to="link" activeClass="active">
        <h4 class="-flex_bottom">
          <span>{{ product.Name }}</span
          ><span class="ml-1 bullet">Edit</span>
        </h4>

        <div class="text-blue">PACKAGE</div>

        <table class="cart_pricing text-slate">
          <tr>
            <td>
              <!-- <span
                v-if="
                  guests &&
                    product.CapacityTypeKey != 2 &&
                    product.CapacityTypeKey != 3
                "
              >
                {{ guests }} guest{{ guests > 1 ? "s" : "" }}
              </span>
              <span
                v-else-if="
                  guests &&
                    (product.CapacityTypeKey == 2 ||
                      product.CapacityTypeKey == 3)
                "
              >
                {{ guests }} selected
              </span>
              <span>
                &nbsp;<currency
                  :fixed="true"
                  :value="product.SubTotal / guests"
                />
                x&nbsp;{{ guests }}&nbsp;
              </span> -->
            </td>

            <td align="right">
              <currency :fixed="true" :value="product.SubTotal" />
            </td>
          </tr>
        </table>

        <section
          v-for="(act, i) in product.Activities"
          :key="'cart-row-package-activity-' + act.EntityHierarchyKey"
          class="_package_activity _flex pt-1"
        >
          <div class="text-slate">
            <small style="text-transform: uppercase; font-size: .7em">{{ i + 1 }} of {{ product.Activities.length }}</small>
            <partner-experience-tag v-if="act.Owner_ClientLocationKey" class="small" style="margin-left:5px;margin-bottom:3px;" />
            <strong style="display: block;" class="mt-0 mb-0">{{ act.Name }}</strong>
            <span>
              {{ act.AppointmentDate | moment("ddd, MMM DD, YYYY") }}
              <span style="white-space: nowrap;">at&nbsp;{{ act.SelectedTimes[0].DisplayName }}</span>
            </span>

            <!-- <pre>{{act.AddOns}}</pre> -->

            <div class="each_time" v-for="(st, n) in act.SelectedTimes" :key="i + 'cart-row-package-selected-times-' + n + '-' + st.Value">
              <!--              <div class="cart_pricing_grid">-->
              <!--                <section>asdf</section>-->
              <!--                <section>pricing</section>-->
              <!--              </div>-->

              <table class="cart_pricing">
                <tr
                  v-for="addon in st.AddOns.filter((a) => !a.IsDeleted)"
                  class="-flex"
                  :key="'cart-row-addons-' + product.OrderEntityKey + '-' + addon.ProductKey"
                >
                  <td>
                    {{ addon.AddOnName }}
                    <span class="text-pencil-light">
                      &nbsp;<currency :fixed="true" :value="addon.PublishedPrice" /> x&nbsp;{{ addon.Quantity }}&nbsp;
                    </span>
                  </td>
                  <td align="right">
                    <currency :fixed="true" :value="addon.PublishedPrice * addon.Quantity" />
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <!-- <pre>AddOns: {{act.SelectedTimes[0].AddOns}}</pre> -->
          <!-- <span>
            <currency :value="act.SubTotal" />
          </span>-->
        </section>
        <div class="flex-start mt-1" style="margin-left: -1px;">
          <i class="material-icons tiny text-blue mr-1">local_offer</i>
          <strong>
            You saved
            <currency :fixed="true" :value="product.TotalSavings" />
            by booking this package.
          </strong>
        </div>
      </router-link>
    </div>

    <a class="close_button" v-on:click.prevent="confirmRemoveFromCart({ ...product, isPackage: true })"></a>

    <!-- <section class="flex mt-2 mb-1">
      <h4>Subtotal</h4>
      <h4>
        <currency :value="product.SubTotal" />
      </h4>
    </section>-->
    <!-- <section class="flex mt-2 mb-0">
      <small>Only XXX spots left</small>
      <div>
        <a class="text-blue" href @click.prevent="modifyLink">Edit reservation</a>
      </div>
    </section>-->
  </div>
  <div v-else>
    <router-link :to="link">
      <div class="cart-row-item">
        <div class="activity-image">
          <div class="client-logo" :style="'background-image: url(' + photo + ')'"></div>
        </div>
        <div class="row-desc">
          <div>
            <div>
              <div class="text-blue text_size-large text_style-bold pkg-title">
                PACKAGE
              </div>
              <span class="activity-name text_size-large text_style-bold">{{ product.Name }}</span>
            </div>
            <!-- RATE INFORMATION -->
            <section class="rate-entry text_size-medium-small">
              <!-- <span
								v-if="
									guests &&
										product.CapacityTypeKey != 2 &&
										product.CapacityTypeKey != 3
								"
							>
								{{ guests }} Guest{{ guests > 1 ? 's' : '' }}
							</span>
							<span
								v-else-if="
									guests &&
										(product.CapacityTypeKey == 2 ||
											product.CapacityTypeKey == 3)
								"
							>
								{{ guests }} selected (
								<span>
									<currency :fixed="true" :value="product.SubTotal / guests" />
									x {{ guests }}
								</span>
								)
							</span> -->
              <span>Package Price</span>
              <span class="subtotal">
                <currency :fixed="true" :value="product.SubTotal" />
              </span>
            </section>

            <!-- PACKAGE CONTENTS -->
            <section
              v-for="(act, i) in product.Activities"
              :key="'cart-row-package-activity-' + act.EntityHierarchyKey"
              class="_package_activity _flex pt-1 text_size-medium-small"
            >
              <div class="text-slate">
                <small style="text-transform: uppercase; font-size: .7em">{{ i + 1 }} of {{ product.Activities.length }}</small>
                <partner-experience-tag v-if="act.Owner_ClientLocationKey" class="small" style="margin-left:5px;margin-bottom:3px;" />
                <strong style="display: block;" class="mt-0 mb-0">{{ act.Name }}</strong>
                <span style="font-weight: 400">
                  {{ act.AppointmentDate | moment("ddd, MMM DD, YYYY") }}
                  <span style="white-space: nowrap;">at&nbsp;{{ act.SelectedTimes[0].DisplayName }}</span>
                </span>
                <div class="each_time" v-for="(st, n) in act.SelectedTimes" :key="i + 'cart-row-package-selected-times-' + n + '-' + st.Value">
                  <span>{{ act.TotalParticipants }} Guest{{ act.TotalParticipants > 1 ? "s" : "" }}</span>
                  <table class="cart_pricing">
                    <tr
                      v-for="addon in st.AddOns.filter((a) => !a.IsDeleted)"
                      class="-flex"
                      :key="'cart-row-addons-' + product.OrderEntityKey + '-' + addon.ProductKey"
                    >
                      <td>
                        {{ addon.AddOnName }}
                        <span class="text-pencil-light">
                          &nbsp;<currency :fixed="true" :value="addon.PublishedPrice" /> x&nbsp;{{ addon.Quantity }}&nbsp;
                        </span>
                      </td>
                      <td align="right">
                        <currency :fixed="true" :value="addon.PublishedPrice * addon.Quantity" />
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
          </div>
        </div>
        <a class="delete_button" v-on:click.prevent="confirmRemoveFromCart({ ...product, isPackage: true })"></a>
      </div>
      <div class="package-savings-msg ">
        <i class="material-icons tiny text-blue mr-1">local_offer</i>
        <div class="text_size-medium-small">
          You saved
          <currency :fixed="true" :value="product.TotalSavings" /> by booking this package.
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PartnerExperienceTag from "@/components/PartnerExperienceTag.vue";

export default {
  components: { PartnerExperienceTag },
  name: "CartRowPackage",
  props: ["product"],
  methods: {
    ...mapActions(["confirmRemoveFromCart"]),
    modifyLink() {
      var identifier = this.product.OrderPackageKey;

      var path =
        "/" +
        this.$route.params.client +
        "/package/" +
        "modify" +
        "/" +
        identifier +
        "/" +
        (this.$route.params.clientAgentKey ? this.$route.params.clientAgentKey + "/start" : "n/start");

      this.$router.push({
        path: path,
      });
    },
  },
  computed: {
    link() {
      var identifier = this.product.OrderPackageKey;

      var path =
        "/" +
        this.$route.params.client +
        "/package/" +
        "modify" +
        "/" +
        identifier +
        "/" +
        (this.$route.params.clientAgentKey ? this.$route.params.clientAgentKey + "/start" : "n/start");

      return path;
    },

    guests() {
      return this.product.Participants ? this.product.Participants : 0;
    },

    photo() {
      return this.product.PhotoDomain + "w_280,h_280,c_fill" + "/v" + this.product.PhotoVersion + this.product.PhotoFolder + "/original";
    },
  },
};
</script>

<style lang="scss" scoped>
.pkg-title,
.activity-name {
  display: flex;
  align-items: center;
  max-width: 90%;
  cursor: pointer;

  &:hover {
    color: var(--highlight);
  }
}

.pkg-title {
  // edit button
  &::after {
    content: "Edit";
    font-size: 10px;
    font-weight: 200;
    color: var(--highlight);
    border: 1px solid var(--highlight);
    border-radius: 3px;
    padding: 1px 3px;
    margin-left: 6px;
    visibility: hidden;
  }

  // mobile
  @media only screen and (max-width: 942px) {
    &::after {
      content: "";
      border: none;
    }
  }
}

.package-savings-msg {
  display: flex;
  padding: 8px 0;
  justify-content: center;
  cursor: default;
}

.activity-image {
  height: 50px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--border-color);
}

.client-logo {
  height: 95%;
  width: 95%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.pkg-table {
  font-weight: 400;
}
</style>
